import StakeContainer from './StakeContainer';

export default StakeContainer;
